<template>
    <div class="w-full h-screen flex flex-col items-center justify-between bg-black">
        <div class="flex flex-col w-full h-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-500 flex flex-row justify-center sticky top-0 text-gray-500">
                <div>Sign for delivery</div>
            </div>
            <div><VueSignature class="w-full h-64" :sig-option="option" :h="'200'" ref="signature"></VueSignature></div>
            <div v-if="error" class="bg-red-500 p-2 w-full">
                <span class="text-white">Wrong signature, please sign</span>
            </div>
            <div class="w-full pt-4 text-center">
                <button @click="sign" class="bg-gray-800 mb-2 p-2 px-12 text-indigo-400 rounded-lg">
                    <i class="fa fa-pen mr-2"></i> Sign
                </button>
                <button @click="reset" class="ml-4 bg-gray-800 mb-2 p-2 px-4 text-red-400 rounded-lg">
                    <i class="fa fa-times mr-2"></i> Reset
                </button>
            </div>
        </div>
        <div class="py-2 border-t border-gray-800 bg-black w-full text-center">
            <button @click="home" class="bg-gray-800 mb-2 p-2 px-16 text-indigo-400 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>

</template>

<script>
    import VueSignature from 'vue-signature';

    export default {
        name: "Signature",
        components : {
            VueSignature
        },
        data: function() {
            return {
                error: false,
                part: 'home',
                option:{
                    penColor:"rgb(255,255,255)",
                    backgroundColor:"rgb(0, 0, 0)"
                }
            }
        },
        methods: {
            sign() {
                const svg = this.$refs.signature.save('image/svg+xml');
                this.$emit("signature", svg);
            },
            reset() {
                this.$refs.signaturePad.undoSignature();
            },
            home() {
                if(this.part==='home') {
                    this.$emit("back")
                } else {
                    this.part = 'home'
                }
            },
        }
    }
</script>

<style scoped>

</style>